import React from 'react';
import { message, notification } from 'antd';
import realAxios from 'axios';
import ReactDOM from 'react-dom';
import config from '../config';

const logError = (error) => {
  realAxios({
    method: 'post',
    url: config.urlEndPointOohShared + 'Log',
    data: {
      module: window.location.href
        .replace(config.urlInternalFrontend, '')
        .replace('http://localhost:4200/', ''),
      action: 'System Error',
      info: error.message
    },
    headers: {
      Authorization: 'bearer ' + window.context.access_token
    }
  })
    .then((response) => {
      console.log('log error success', response);
    })
    .catch((err) => {
      console.log('log error failed', err, err.message, err.response);
    });
};

const axiosWithErrorHandler = (params): Promise => {
  return realAxios(params)
    .then((response) => {
      // console.log('realAxios', response);
      return response;
    })
    .catch((error) => {
      if (!error.response || error.response?.status === 401) {
        window.location.href = config.urlExternalFrontend;
        //console.log('redirect to home');
        return;
      }

      if (error.response.status === 500) {
        //logError(error);
      }

      const listDisableAutoCloseApi = ['VisualPlan/Step1'];

      const isDisableAutoClose = listDisableAutoCloseApi.some((i) =>
        error.response.config.url.includes(i)
      );

      const errorMessage =
        error.response.status === 500
          ? 'Error system please contact your SMART Administrator or Service Desk'
          : typeof error.response.data === 'string'
          ? error.response.data
          : Array.isArray(error.response.data)
          ? error.response.data.map((msg, id) => <p key={id}>{msg}</p>)
          : 'Error has occurred.';

      ReactDOM.render(
        <>
          {notification.error({
            message: 'Error',
            description: errorMessage,
            duration: isDisableAutoClose ? 0 : 4.5
          })}
        </>,
        document.getElementById('message')
      );

      // console.log('realAxios error', error.response);
      throw error;
    });
};

const axios = (params): Promise => {
  // console.log('params', params, window.context);

  const mandatoryFields = {
    userAccount: window.context.name
  };

  const mandatoryHeaders = {
    Authorization: 'bearer ' + window.context.access_token
  };

  if (params?.method?.toLowerCase() === 'get') {
    return axiosWithErrorHandler({
      ...params,
      headers: {
        ...params.headers,
        ...mandatoryHeaders
      },
      params: {
        ...params.params
        //...mandatoryFields,
        // userRole: window.context.UserRole,
        // userId: window.context.UserId,
      }
    });
  }

  if (
    params?.method?.toLowerCase() === 'post' ||
    params?.method?.toLowerCase() === 'put' ||
    params?.method?.toLowerCase() === 'delete'
  ) {
    return axiosWithErrorHandler({
      ...params,
      headers: {
        ...params.headers,
        ...mandatoryHeaders
      },
      data: {
        ...params.data
        //...mandatoryFields,
      }
    });
  }

  // console.log('params method is not known');
  return axiosWithErrorHandler(params);
};

export default axios;
